import { appRoutes } from "@/app/router";
import { buildAppWindowUrl } from "@/modules/window/build-url";

export const getWindowSlackOAuthRedirectUrl = () =>
  buildAppWindowUrl({
    path: appRoutes.integrationsSlackCallback({}).path,
  }).toString();
